import { ReactComponent as CloseIcon } from "../../../../../Assets/icon/close.svg";

const SessionCategory = ({onClose, hideCloseIcon = false, selectedSession, setSelectedSession, setPage, isReschedule, setIsGroupModalOpen }) => {

  return (
    <div className='session-selection-container'>
        <div className='session-selection-header'>
            <p>Aris Live Session</p>
            {!hideCloseIcon && <CloseIcon style={{cursor:'pointer'}} onClick={onClose}/>}
        </div>
        <div className='session-buttons-container'>
            <div className={`session-button ${selectedSession === 'private' && 'selected'}`} onClick={() => setSelectedSession('private')}>
                Dialogue for You
            </div>
            <div className={`session-button ${selectedSession === 'group' && 'selected'}`} onClick={() => setSelectedSession('group')}>
                Dialogue for Two
            </div>
            {/* <div className={`session-button ${selectedSession === 'small_group' && 'selected'}`} onClick={() => setSelectedSession('small_group')}>
                Dialogue for group
            </div> */}
        </div>
        <div className="buttons-container">
            {!isReschedule &&
                <div 
                    className="start-button" 
                    onClick={() => {
                        if(selectedSession === 'private') {
                            window.location.href = '/coach/private'
                        } else {
                            setIsGroupModalOpen(true);
                        }
                    }}
                >
                    Start now
                </div>
            }
            <div className="schedule-button" onClick={() => setPage('date')}>Schedule for later</div>
        </div>
    </div>
  )
}

export default SessionCategory